import React from 'react';
import { motion } from 'framer-motion';
import { Heart, Target, Music, ChevronRight, Sparkles, Smile } from 'lucide-react';

const SoftSkills = ({ softSkills, interests, objective }) => {
  return (
    <section className="py-20 section-spacing">
      <div className="grid md:grid-cols-2 gap-6">
        {/* Soft Skills */}
        <motion.div
          initial={{ opacity: 0, x: -50 }}
          whileInView={{ opacity: 1, x: 0 }}
          transition={{ duration: 0.6 }}
          viewport={{ once: true }}
          className="bg-dark-surface rounded-xl p-6 border border-violet-500/20"
        >
          <div className="flex items-center gap-3 mb-6">
            <div className="bg-violet-600/20 p-3 rounded-full">
              <Heart className="text-violet-400" size={24} />
            </div>
            <div>
              <h2 className="text-2xl font-bold gradient-text">Soft Skills</h2>
              <div className="text-xs font-mono text-gray-500">$ cat soft-skills.json</div>
            </div>
          </div>

          <div className="space-y-3">
            {softSkills.map((skill, index) => (
              <motion.div
                key={index}
                initial={{ opacity: 0, x: -20 }}
                whileInView={{ opacity: 1, x: 0 }}
                transition={{ delay: index * 0.1 }}
                className="flex items-center gap-3 p-3 bg-dark-card rounded-lg border border-dark-border hover:border-violet-500/30 transition-colors"
              >
                <Smile size={18} className="text-violet-400 flex-shrink-0" />
                <span className="text-gray-300 text-sm">{skill}</span>
              </motion.div>
            ))}
          </div>
        </motion.div>

        {/* Centres d'intérêt */}
        <motion.div
          initial={{ opacity: 0, x: 50 }}
          whileInView={{ opacity: 1, x: 0 }}
          transition={{ duration: 0.6 }}
          viewport={{ once: true }}
          className="bg-dark-surface rounded-xl p-6 border border-violet-500/20"
        >
          <div className="flex items-center gap-3 mb-6">
            <div className="bg-violet-600/20 p-3 rounded-full">
              <Music className="text-violet-400" size={24} />
            </div>
            <div>
              <h2 className="text-2xl font-bold gradient-text">À côté</h2>
              <div className="text-xs font-mono text-gray-500">$ echo $HOBBIES</div>
            </div>
          </div>

          <div className="space-y-4">
            {interests.map((interest, index) => (
              <motion.div
                key={index}
                initial={{ opacity: 0, y: 20 }}
                whileInView={{ opacity: 1, y: 0 }}
                transition={{ delay: index * 0.1 }}
                className="flex items-center gap-4 p-4 bg-dark-card rounded-lg border border-dark-border"
              >
                <span className="text-3xl">{interest.icon}</span>
                <div>
                  <h3 className="text-white font-semibold">{interest.name}</h3>
                  <p className="text-xs text-gray-400 font-mono">{interest.description}</p>
                </div>
              </motion.div>
            ))}
          </div>
        </motion.div>
      </div>

      {/* Objectif */}
      <motion.div
        initial={{ opacity: 0, y: 50 }}
        whileInView={{ opacity: 1, y: 0 }}
        transition={{ duration: 0.6, delay: 0.3 }}
        viewport={{ once: true }}
        className="mt-6 bg-gradient-to-r from-violet-900/30 via-dark-surface to-blue-900/30 rounded-xl p-8 border border-violet-500/20 relative overflow-hidden"
      >
        <div className="absolute top-0 right-0 text-8xl opacity-5 font-mono">"</div>
        
        <div className="relative z-10">
          <div className="flex items-center gap-3 mb-4">
            <Target className="text-violet-400" size={28} />
            <h2 className="text-2xl font-bold gradient-text">Objectif</h2>
          </div>
          <p className="text-gray-300 text-lg leading-relaxed pl-4 border-l-4 border-violet-500">
            {objective}
          </p>
          <div className="mt-4 flex items-center gap-2 text-sm font-mono text-gray-500">
            <Sparkles size={14} className="text-yellow-400" />
            <span>Ready for new challenges</span>
          </div>
        </div>
      </motion.div>
    </section>
  );
};

export default SoftSkills;